<title>Profile</title>
<style>
    .Page_Title {
    position: relative;
    text-align: center;
    font-family: Montserrat;
    font-style: normal;
    font-weight: lighter;
    font-size: 50px;
    color: rgba(0, 0, 0, 1);
    display: block;

    }

.Company_Logo_Container {
	border-style: solid;
	border-width: 3px;
	border-radius: 20%;
	padding: 2rem;
	width: 20%;
	height: 150px;
	margin-left: 2rem;
	overflow: hidden;
}

.Button_Text
{
	position: relative;
	font-family: Montserrat;
	font-style: normal;
	text-align: center;
}

.Image_Button {
	color: rgb(219, 219, 219);
	border-width: 2px;
	border-radius: 10px;
	padding: 1rem;
	margin-bottom: 1rem;
	display: inline-block;
	cursor: pointer;
}

.Image_Button:hover {
	color: black;
}


.wrapper-center {
	display: inline-flex;
	justify-content: center;
	align-items: center;
	width: 100%;
}

:global(.profile-pics) {
	padding: 1rem 2rem;
	border: black 1px solid;
	/* display: inline-block; */
	margin: 1rem;
	border-radius: 5px;
	height: auto;
	/* max-width: 50%; */
	position: relative;
	width: auto;
}

.block-wrapper {
	display: inline-block;
}

.profile-pic--wrapper {
	display: inline-flex;
	flex-direction: column;
}

.profile-pic--wrapper button.deleteImg {
	background: rgb(59, 59, 59);
	border: 0px solid black;
	border-radius: 3px;
	color: white;
	margin: 0px 30px;
	margin-top: 2px;
	margin-bottom: 5px;
	padding: 5px;
	cursor: pointer;
}

</style>
<script>
	import { Col, Container, Row } from "sveltestrap";
	import {getToken} from "../js-core/conn/auth/auth-main"
	import UploadProfilePic from './UploadProfilePic.svelte'
	import ChangeProfileDesc from '../components/shared/forms/ChangeDesc.svelte'
	import GeneralImg from "../components/shared/img/GeneralImg.svelte"
	let uploadImageVis = false
	async function getProfilePics() {
		const res = await BSFetch(`tv-owner/all-profile-pics`, {
			method: "GET",
			headers: {
				authorization: getToken(),
			},
			mode: "cors",
			cache: "no-cache"})	
		const ids = (await res.json()).response.picIds.map(picItem => picItem.id)
		return ids
	}

    async function updateDesc(description) {
		console.log(description)
        const res = await BSFetch("tv-owner/profile/update-description", {
          method: "POST",
          headers: {
            authorization: getToken(),
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ description }),
          mode: "cors",
          cache: "no-cache"
        });
        if (res.status !== 204) {
            throw "There was an error updating your description"
        } else {
            window.location.reload()
        }
    }

	async function deleteImg(id) {
		const res = await BSFetch(`tv-owner/profile-pic/${id}`, {
			method: "DELETE",
			headers: {
				authorization: getToken(),
			},
			mode: "cors",
			cache: "no-cache"})
		if (res.status === 204) {
			window.location.reload()
		} else {
			deleteError[id] = true
		}
	}
	let deleteError = {}
	let getProfilePicsProm = getProfilePics() 
	let descModalOpen = false
	// let description = ""
	async function getDescription() {
		try {
			const res = await BSFetch(`tv-owner/profile/description`, {
				method: "GET",
				headers: {
					authorization: getToken(),
				},
				mode: "cors",
				cache: "no-cache"})
			if (res.status !== 200) {
				throw "error getting description"
			} else {
				const description = (await res.json()).response.description
				return description
			}
		} catch (e) {
			console.error(e)
			throw "error getting description"
		}
	}
	let getDescriptionProm = getDescription()
</script>
{#if uploadImageVis === true}
	<UploadProfilePic bind:isOpen={uploadImageVis} />
{/if}
<Container>
	<Row class="justify-content-center">
		<Col>
			<h1 class="text-center">{window.getBusinessName()}'s Profile</h1>
		</Col>
	</Row>
	<Container class="Description">
		{#await getDescriptionProm}
				Loading your description
		{:then description}
			<Row>
				<Col>
					<span>Company Description</span>
				</Col>
			</Row>
			<Row>
				<Col>
					<div class="Description_Text">
						<span>{description}</span>
					</div>
				</Col>
			</Row>
			<Row>
				<Col>
					<button class="normal" on:click="{() => descModalOpen = true}">Change Description</button>
					{#if descModalOpen}
						<ChangeProfileDesc bind:open={descModalOpen} description={description} updateDesc={updateDesc} />
					{/if}
				</Col>
			</Row>
			{:catch error}
				There was an error in getting your description
			{/await}
	</Container>
	<Container class="profile-pics">
		<Row>
			<Col>
				{#await getProfilePicsProm}
					Loading your profile pictures
				{:then picIds}
					<Row class="justify-content-end">
						<button class="Image_Button main" on:click={() => uploadImageVis = true}>	
							<div class="Button_Text">	
								<span>add a picture</span>
							</div>
						</button>
					</Row>
					<Row>
						<Col>
							<p>Your Profile Pictures:</p>
						</Col>
					</Row>
					{#each picIds as picId}
					<Row>
						<Col sm="4">
							<div class="wrapper profile-pic--wrapper">
								<GeneralImg id={picId} height=100 />
								<button class="deleteImg" on:click={() => deleteImg(picId)}>
									Remove
								</button>
							{#if deleteError[picId]}
								There was an error deleting your profile picture
							{/if}
							</div>
						</Col>
					</Row>
					{/each}
				{:catch error}
					There was an error in getting your profile pictures
				{/await}
			</Col>
		</Row>
	</Container>

		<!-- <div class= "Company_Logo_Container">
			<img style="width:100%;" src= "static/images/Company_Logo.png" alt= "Company Logo">
		</div> -->
		<!-- <div class="Price_Header_Text"><span>Price Range</span></div>
		<div class="Price_Range_Housing">
			<div class="Price_Text">
				<span>$20 to $40</span>
			</div>
		</div> -->
</Container>
